import $ from 'jquery'

export function setDealerInfo(form) {
  const selectedDealer = form.find('.js-dealers-list').children('option:selected')
  const dealerName = form.find('.js-dealers-list').val()
  let emailDealerDetails = `<p><strong>${encodeURIComponent(dealerName)}</strong><br />${selectedDealer.attr(
    'data-address'
  )}<br />`
  emailDealerDetails = `${emailDealerDetails}Phone: ${selectedDealer.attr('data-phone')}<br />`
  return emailDealerDetails
}

export function getDealerId(form) {
  return form.find('.js-dealers-list').children('option:selected').attr('data-id')
}

export function loadDealers(element) {
  if (element.hasClass('js-dealers-loaded')) {
    return
  }

  let dealers = '<option value="">Select a Dealer</option>'
  $.ajax({
    type: 'GET',
    dataType: 'json',
    url: 'https://dealers.lodeking.com/api/dealers?truncate=true&apikey=b343ce58-811f-4a2c-9963-bb77f6c9943e',
    success: function (data) {
      if (window.location.host.includes('localhost')) {
        data.unshift({
          id: '585d60616f4b772149d20312',
          name: 'Test Localhost Dealer',
          phone: '204-325-4345',
          address: '135 Canada Street',
          city: 'Winkler',
          province: 'MB',
          postcode: 'R6W 4B1',
          leads: {
            to: 'jwiebe@lodeking.com',
            bcc: 'jwiebe@lodeking.com',
          },
        })
      }
      for (let i = 0; i < data.length; i++) {
        if (data[i].public === false) continue
        dealers =
          `${dealers}<option value="${data[i].name}" data-phone="${data[i].phone}" data-address="${data[i].address}, ${data[i].city}, ${data[i].province}, ${data[i].postcode}" data-email="${data[i].leads.to}" data-manager="${data[i].leads.bcc}" data-id="${data[i].id}">${data[i].name} (${data[i].city} ${data[i].province}) ` +
          `</option>`
      }

      element.html(dealers).addClass('js-dealers-loaded')
    },
    error: function () {},
  })
}
